import { HttpClient } from '@angular/common/http';
import {  Component, OnDestroy, OnInit,Inject, ViewChild, OnChanges, DoCheck} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { TableEditBase } from '../../../_infrastructure/TableEdit/TableEditBase';
import { ClinicalSituationComponent } from './clinical-situation.component';
import { ControlContainer, NgForm, FormControl, NgControl, NgModel, AbstractControl } from '@angular/forms';
import { SubscriberInformationService } from '../../../_infrastructure/SubscriberInfo/SubscriberInformationService';
import { ModalService } from '../../../_infrastructure/Modal/ModalService';
import DateHelpers  from '../../../_infrastructure/DateHelpers';

@Component({
    selector: 'incapacity-table-edit',
    templateUrl: './clinical-situation-edit.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class IncapacityTableEditComponent extends TableEditBase<models.ClinicalSituationEntryVM> implements OnInit, OnDestroy {

  //@CommonData(DomainCodes.domains)
  //public domains: models.DimensionVM[];
  //@CommonData(DomainCodes.yesNo)
  //public yesNo: models.DimensionVM[];
  //@CommonData(DomainCodes.subscriberSituations)
  //public subscriberSituations: models.DimensionVM[];
  //@CommonData(DomainCodes.scheduleTypes)
  //public scheduleTypes: models.DimensionVM[];
  //@CommonData(DomainCodes.remunerationTypes)
  //public remunerationTypes: models.DimensionVM[];
  
  public subscriber: models.SubscriberInformationVM;

  public maxDate: Date = new Date();

  public minDate: Date;

  constructor(@Inject(ClinicalSituationComponent) private parent: Component, private subscriberinfoService: SubscriberInformationService,
    private modalService: ModalService) {
      super(parent, modalService);
  }
 
  ngOnInit(): void {
    super.ngOnInit();
    this.subscriberinfoService.getCurrentSubscriber().subscribe((subscriber) => {
      this.subscriber = subscriber;
      this.minDate = new Date(subscriber.dateOfBirth);
    })
  }

  ngOnDestroy(): void {
  }

  onEdit(isEdit: boolean) {
    super.markTouched();
    super.onEdit(isEdit);
  }

  formatDate(event: any) {
    DateHelpers.formatDateGeneral(event);
  }

  onlyNumbers(event: any) {
    DateHelpers.onlyNumbers(event);
  }

  onDateChange(event: any, dp: any) {
    let object = new Date(this.item.diagnoseDate).toISOString().split('T')[0]
    DateHelpers.onDateChange(event, dp, object);
  }
}
